import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import StyleButton from './StyleButton'

function InlineStyleControls({ editorState, onToggle }) {
  const styles = [
    { label: 'bold', style: 'BOLD' },
    { label: 'italic', style: 'ITALIC' },
  ]

  const currentStyle = editorState.getCurrentInlineStyle()

  return (
    <Fragment>
      {styles.map(type => (
        <StyleButton
          key={type.label}
          isActive={currentStyle.has(type.style)}
          label={type.label}
          onToggle={onToggle}
          style={type.style}
        />
      ))}
    </Fragment>
  )
}

InlineStyleControls.propTypes = {
  editorState: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
}

export default InlineStyleControls
